import { render, staticRenderFns } from "./AgendaSpecializzazioniEditComponent.vue?vue&type=template&id=2a3708e5"
import script from "./AgendaSpecializzazioniEditComponent.vue?vue&type=script&lang=js"
export * from "./AgendaSpecializzazioniEditComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaSpecializzazioniEditComponent.vue?vue&type=style&index=0&id=2a3708e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports